(() => {
  // app/scripts/section-categories-related.js
  var { debounceTime } = theme;
  customElements.define("cus-categories-related", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.btnShow = this.querySelector(".jsFilterShowMoreCus");
      this.slider = this.querySelector(".slider-list");
      this.itemCount = this.btnShow.dataset.total;
      this.count = this.querySelector(".js-count-show-more");
      this.content = this.count.textContent;
      this.intWidth = window.innerWidth;
      if (!this.querySelector(".slider-list.tns-slider")) {
        this.init();
        this.resize();
      } else {
        this.resize();
      }
      this.btnShow.addEventListener("click", (e) => {
        this.handleClick(e);
      });
    }
    init() {
      let itemPerRow = this.getItemPerRow();
      let style = window.getComputedStyle(this.slider);
      if (style.flexWrap === "wrap") {
        if (this.itemCount > itemPerRow) {
          const textReplace = this.count.dataset.textReplace;
          let itemReplace = this.itemCount - itemPerRow;
          this.count.textContent = this.content.replace(textReplace, itemReplace);
          const filterList = this.slider.querySelectorAll(".jsFilterToggleCus");
          [...filterList].forEach((item, index) => {
            if (index >= itemPerRow) {
              item.classList.add("none");
            } else {
              item.classList.remove("none");
            }
          });
          this.btnShow.setAttribute("data-more", "true");
        } else {
          this.btnShow.setAttribute("data-more", "false");
        }
        if (this.itemCount != itemPerRow) {
          this.btnShow.classList.remove("none");
        } else {
          this.btnShow.classList.toggle("none", true);
        }
      }
    }
    resize() {
      window.addEventListener("resize", debounceTime((e) => {
        if (this.intWidth == window.innerWidth)
          return;
        this.intWidth = window.innerWidth;
        this.btnShow.classList.add("none");
        if (!this.querySelector(".slider-list.tns-slider")) {
          this.handleResize();
        } else {
          const filterList = this.slider.querySelectorAll(".jsFilterToggleCus");
          [...filterList].forEach((item) => {
            item.classList.remove("none");
          });
        }
      }, 300));
    }
    handleResize() {
      let filterList = this.slider.querySelectorAll(".jsFilterToggleCus");
      [...filterList].forEach((item) => {
        item.classList.remove("none");
      });
      let itemPerRow = this.getItemPerRow();
      [...filterList].forEach((item, index) => {
        if (index >= itemPerRow) {
          item.classList.toggle("none", true);
        } else {
          item.classList.toggle("none", false);
        }
      });
      if (this.itemCount > itemPerRow) {
        const textReplace = this.count.dataset.textReplace;
        let itemReplace = this.itemCount - itemPerRow;
        this.count.textContent = this.content.replace(textReplace, itemReplace);
        this.btnShow.setAttribute("data-more", "true");
      } else {
        this.btnShow.setAttribute("data-more", "false");
      }
      if (this.itemCount != itemPerRow) {
        this.btnShow.classList.remove("none");
      } else {
        this.btnShow.classList.toggle("none", true);
      }
    }
    handleClick({ target }) {
      const itemPerRow = this.getItemPerRow();
      if (target.getAttribute("data-more") == "true") {
        const filterList = this.slider.querySelectorAll(".jsFilterToggleCus.none");
        [...filterList].forEach((item, index) => {
          item.classList.remove("none");
        });
        target.setAttribute("data-more", "false");
      } else {
        const filterList = this.slider.querySelectorAll(".jsFilterToggleCus");
        [...filterList].forEach((item, index) => {
          if (index >= itemPerRow) {
            item.classList.toggle("none", true);
          } else {
            item.classList.toggle("none", false);
          }
        });
        const textReplace = this.count.dataset.textReplace;
        let itemReplace = this.itemCount - itemPerRow;
        this.count.textContent = this.content.replace(textReplace, itemReplace);
        target.setAttribute("data-more", "true");
      }
    }
    getItemPerRow() {
      const items = this.slider.children;
      let itemsPerRow = 0;
      let firstItemTop = items[0].getBoundingClientRect().top;
      for (let i = 0; i < items.length; i++) {
        if (items[i].getBoundingClientRect().top === firstItemTop) {
          itemsPerRow++;
        } else {
          break;
        }
      }
      return itemsPerRow;
    }
  });
})();
